import { fetchSendTimer } from '../repositories/browser-telemetry/v1/send-timer';
import { fetchSendIncrement } from '../repositories/browser-telemetry/v1/send-increment';
export var sendTelemetryTimer = function sendTelemetryTimer(_ref) {
  var httpApi = _ref.httpApi,
      key = _ref.key,
      value = _ref.value;

  try {
    fetchSendTimer({
      httpApi: httpApi,
      parameters: {
        key: key,
        value: value
      }
    });
    /* istanbul ignore next */
  } catch (e) {// Ничего не логируем
  }
};
export var sendTelemetryCounter = function sendTelemetryCounter(_ref2) {
  var httpApi = _ref2.httpApi,
      key = _ref2.key,
      value = _ref2.value;

  try {
    fetchSendIncrement({
      httpApi: httpApi,
      parameters: {
        key: key,
        value: value
      }
    });
    /* istanbul ignore next */
  } catch (e) {// Ничего не логируем
  }
};